export default __webpack_public_path__ + "static/media/bgyellowwhiteshadow.b5bbf17a.png";